import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

import AppContext from 'flow/contexts/app-context';
import InviteColleague from 'flow/components/invite/InviteColleague';
import { navigateBack } from 'flow/actions/navigate-actions';
import { inviteExternalContact } from 'flow/actions/contact-actions';

class InviteColleagues extends React.PureComponent {
    static propTypes = {
        inviteContact: PropTypes.func.isRequired,
        setNumber: PropTypes.func.isRequired,
    };

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            number: '',
        };
    }

    handleInviteExternalContact = () => {
        const { inviteContact } = this.props;
        const { number } = this.state;

        const parsedNumber = parsePhoneNumberFromString(number);

        const validMobileNumber =
            parsedNumber && parsedNumber.isValid() ? number : null;
        const countryCode =
            parsedNumber && parsedNumber.isValid() ? parsedNumber.country : '';

        const NumberDTO = {
            number: validMobileNumber,
            countryCode: countryCode,
        };

        const invitationDTO = {
            number: NumberDTO,
        };

        inviteContact(invitationDTO);
        this.setState({ number: '' });
    };

    handleUpdateNumber = (number) => {
        this.setState({ number });
        this.props.setNumber(number);
    };

    render() {
        const { number } = this.state;

        return (
            <InviteColleague
                number={number}
                updateNumber={this.handleUpdateNumber}
            />
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    const { location } = props;
    return {
        inviteContact: (invitationDTO) =>
            dispatch(inviteExternalContact(invitationDTO)),
        handleExit: () => dispatch(navigateBack(location)),
    };
};

export default connect(mapDispatchToProps)(InviteColleagues);
